import { api } from "@/lib/api";

export async function downloadFile(path, fallbackName, forceName = false) {
  const r = await api.get(path, { responseType: "blob" });
  const cd = r.headers?.["content-disposition"] || "";
  const utf = /filename\*=UTF-8''([^;]+)/.exec(cd);
  const plain = /filename="?([^";]+)"?/.exec(cd);
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = forceName ? fallbackName : utf ? decodeURIComponent(utf[1]) : plain ? plain[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
